import React, {useEffect} from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import { LabelText } from '../../../components/Language';
import HeaderTitle from '../../../hoc/HeaderTitle';
import './help.css';

export default function Support(props)
{
    useEffect(() => { 
        props.setSelectedNavItem(window.location.pathname.replace(/[/]/g, ''));
    }, []);

    useEffect(() => { 
      if(props.isLogout)
      {
        props.clearSessionData();
        props.setLogoutFalse(); 
      }
    }, [props.isLogout]); 

    return (
    <div className="sidebar-bottomcontent-container">
      <div className="sidebar-bottomcontent-container-row">
        <div className="sidebar-bottomcontent-container-col">
          <></>
        </div>
        <div className="sidebar-bottomcontent-container-next-col">
            <div className="main-contents">
              <div className="main-content"> 
                <Container className="support-container">
                  <Row > 
                    <HeaderTitle className = "support-title-container col">
                        <span className="support-title-align">
                          <LabelText tid="help" /> - <LabelText tid="support" />
                        </span>
                        <span className="bp-code-align">
                          {props.BusinessPartnerCode}
                        </span>
                    </HeaderTitle>
                  </Row>
                  <Row > 
                    <div className = "support-text-container row">  
                      <span className="support-content1 row">     
                        <LabelText tid="support_line1" /> 
                      </span> 
                      <span className="support-content2 row">                             
                        <LabelText tid="support_line2" /> 
                      </span> 
                      <span className="support-content3 row"> 
                        <LabelText tid="support_line3" />
                      </span> 
                    </div>
                   </Row>
                   <Row>
                     <div className="support-footer"></div>
                   </Row>
                </Container>
              </div>
            </div> 
        </div>
      </div>
    </div>);
}